const DIACRITICS = /[\u0300-\u036f]/g;

export function getFamilyNamePart(value: string): string {
  return value.split(':', 1)[0]?.trim() ?? '';
}

export function normalizeAutoFillFamilyName(value: string): string {
  return value
    .normalize('NFKD')
    .replace(DIACRITICS, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/[_:/-]+/g, ' ')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

export function decomposeFamilyNameToKeys(value: string): string[] {
  const normalized = normalizeAutoFillFamilyName(getFamilyNamePart(value));
  const seen = new Set<string>();

  return normalized.split(' ').filter((key) => {
    if (!key || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}
